import {
  PagamentoEventoDtoSchema,
  type PagamentoEventoDto,
} from '@lance-x/shared';
import type { ApiClient } from '../index';

/**
 * Phase 19 v1.4 — PIX-01. Empresa-side endpoints for the checkout flow.
 *
 * Routes:
 *   POST /pagamentos/evento/:eventoId/pix-charge — emit PIX QR
 *   GET  /pagamentos/evento/:eventoId/status     — poll charge state
 *
 * The empresa checkout page (`/eventos/:id/pagar`) calls `criarPixCharge`
 * once on first render, then polls `getStatus` every 5s until `status` is
 * no longer 'pendente'. Backend is idempotent on `criarPixCharge` so a
 * stale frontend retry never double-charges.
 */
export class PagamentosEndpoints {
  constructor(private readonly client: ApiClient) {}

  criarPixCharge(eventoId: string): Promise<PagamentoEventoDto> {
    return this.client.post(
      `/pagamentos/evento/${eventoId}/pix-charge`,
      undefined,
      { responseSchema: PagamentoEventoDtoSchema },
    );
  }

  getStatus(eventoId: string): Promise<PagamentoEventoDto> {
    return this.client.get(`/pagamentos/evento/${eventoId}/status`, {
      responseSchema: PagamentoEventoDtoSchema,
    });
  }
}
